var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_c('equip-table',{attrs:{"title":"Cabin / Outdoor","title-heading":"h4","site-id":this.siteId,"owner-id":this.ownerId,"site-data":_vm.siteData,"show-qr-code":_vm.showQrCode,"filter-col":"category","filter-val":"Buildings"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }